import React from 'react'
import { BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { SiDiscord } from 'react-icons/si';

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
         <a href="https://www.linkedin.com/in/evan-aldrin-cinco-38b59920a/" target="_blank" rel="noopener"> 
           <BsLinkedin /> 
         </a>
        </div>
        <div>
         <a href="https://www.facebook.com/evan.cinco/" target="_blank" rel="noopener">
           <FaFacebookF />
         </a>
        </div>
        <div>
           <a href="https://www.discordapp.com/users/251945632099467265" target="_blank" rel="noopener">
           <SiDiscord /> 
           </a>
        </div>
    </div>
  )
}

export default SocialMedia